/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_IncotermInputs */

const en_reference_field_incoterm = /** @type {(inputs: Reference_Field_IncotermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incoterm`)
};

/**
* | output |
* | --- |
* | "Incoterm" |
*
* @param {Reference_Field_IncotermInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_incoterm = /** @type {((inputs?: Reference_Field_IncotermInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_IncotermInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_incoterm(inputs)
});